import React, { useEffect, useState } from 'react';

import GenericEditable from './shared/GenericEditable';
import DisplayLineAndStage from './pipeline/pipeline_and_stage/DisplayLineAndStage';
import EditLineAndStage from './pipeline/pipeline_and_stage/EditLineAndStage';

/**
 * Displays "Line > Stage" that is editable in popup.
 * - `Pipeline`: `{string id, string name, int order, list<PipelineStage> pipelineStages}`
 * - `PipelineStage`: `{string id, string pipelineId, string name, int order}`
 * @param {object} [pipeline] Initial value.
 * @param {object} [pipelineStage] Initial value.
 * @param {object} [pipelines] Pipelines containing stages.
 * @param {function} [handleSave] [async (string lineId, string stageId) => {bool success, string message}].
 */
const EditablePipelineAndStage = ({ pipeline: onLoadPipeline, pipelineStage: onLoadPipelineStage, pipelines, handleSave: syncChanges }) => {
    const [pipeline, _setPipeline] = useState(onLoadPipeline);
    const [initialPipeline, setInitialPipeline] = useState(onLoadPipeline);
    const [pipelineStage, setPipelineStage] = useState(onLoadPipelineStage);
    const [initialPipelineStage, setInitialPipelineStage] = useState(onLoadPipelineStage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setPipeline = (newPipeline) => {
        if (newPipeline.id === pipeline.id) {
            return;
        } else if (newPipeline.id === initialPipeline.id) {
            setPipelineStage(initialPipelineStage);
        } else {
            setPipelineStage(newPipeline.pipelineStages[0]);
        }
        _setPipeline(newPipeline);
    };

    useEffect(() => {
        setPipelineStage(onLoadPipelineStage);
        setInitialPipelineStage(onLoadPipelineStage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onLoadPipelineStage]);

    useEffect(() => {
        setPipeline(onLoadPipeline);
        setInitialPipeline(onLoadPipeline);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onLoadPipeline]);

    const valueHasntChanged = () => {
        return pipeline?.id === initialPipeline.line?.id && pipelineStage?.id === initialPipelineStage?.id;
    };

    const handleSave = async () => {
        const response = await syncChanges(pipeline, pipelineStage);
        if (response.success) {
            setInitialPipeline(pipeline);
            setInitialPipelineStage(pipelineStage);
        }
        return response;
    };

    const handleCancel = () => {
        setPipeline(initialPipeline);
        setPipelineStage(initialPipelineStage);
    };

    return (
        <div className='editable-line-and-stage'>
            <GenericEditable {...{ handleSave, handleCancel, valueHasntChanged }}>
                <DisplayLineAndStage pipeline={initialPipeline} pipelineStage={initialPipelineStage} />
                <EditLineAndStage
                    {...{
                        pipeline,
                        setPipeline,
                        pipelineStage,
                        setPipelineStage,
                        pipelines,
                    }}
                />
            </GenericEditable>
        </div>
    );
};

export default EditablePipelineAndStage;
